import React from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CollapseClose, CollapseOpen } from "../../../../assets/images";
import { CircularAvatar } from "../../../commons";
import GstTableHeader from "../../../Gst/common/GstTableHeader";
import {} from "../../../../constant/timeSheetReportDropDown/timeSheetListConst";
import { reverseDate } from "../../../../utils/commonFunctions";
import { USER_WISE_INNER_HEADERS } from "../../../../constant/tableHeadersConstants/UserAndClientWiseOCRReportConst";
import { InvoiceUserData } from "../../../../redux/listing/listingTypes";

type AppProps = {
  data: InvoiceUserData[] | [];
  tableHeader: TableHeadersType[] | [];
  setData: React.Dispatch<React.SetStateAction<[] | InvoiceUserData[]>>;
};
const UserWiseTableData = ({ data, tableHeader, setData }: AppProps) => {
  const handleClick = (id: number) => {
    let newClientData = data?.map((item: InvoiceUserData) => {
      if (+item?.user_id === id) {
        return { ...item, isOpen: !item?.isOpen };
      } else {
        return { ...item };
      }
    });
    setData([...newClientData]);
  };
  return (
    <>
      {data?.length > 0 &&
        data?.map((singleData: InvoiceUserData, index: number) => {
          return (
            <>
              <tr
                style={{
                  borderBottom:
                    index === data?.length - 1 ? "1px solid #D5DADF" : "",
                }}
              >
                {tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value === "user_name") {
                    return (
                      <td>
                        <div>
                          <div
                            className="d-flex justify-content-sm-start"
                            style={{ gap: "10px" }}
                          >
                               {singleData?.isOpen ? (
                          <img
                            width="20px"
                            onClick={() => handleClick(+singleData?.user_id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseOpen}
                            className="accordion-arrow"
                            alt=""
                          />
                        ) : (
                          <img
                            width="20px"
                            onClick={() => handleClick(+singleData?.user_id)}
                            style={{ cursor: "pointer" }}
                            src={CollapseClose}
                            className="accordion-arrow"
                            alt=""
                          />
                        )}
                            {
                              <CircularAvatar
                                name={
                                  singleData?.created_by?.first_name +
                                  " " +
                                  singleData?.created_by?.last_name
                                }
                                image={
                                  singleData?.created_by?.profile_pic
                                    ? singleData?.created_by?.profile_pic?.file_url
                                    : ""
                                }
                              />
                            }
                            <div>
                              <span>
                                {singleData?.created_by?.first_name +
                                  " " +
                                  singleData?.created_by?.last_name}
                              </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header.value === "expenses") {
                    return (
                      <td style={{ borderBottom: "1px solid #D5DADF" }}>
                    
                          <div>
                            <span style={{ fontWeight: 600 }}>
                              {singleData?.expense_count}
                            </span>
                          </div>
                        
                      </td>
                    );
                  } else if (header.value === "sales") {
                    return (
                      <td style={{ borderBottom: "1px solid #D5DADF" }}>
                       
                          <div>
                            <span style={{ fontWeight: 600 }}>
                              {singleData?.sales_count}
                            </span>
                          </div>
                        
                      </td>
                    );
                  } else if (header.value === "total") {
                    return (
                      <td style={{ borderBottom: "1px solid #D5DADF" }}>
                       
                          <div>
                            <span style={{ fontWeight: 600 }}>
                              {singleData?.total_count}
                            </span>
                          </div>
                      </td>
                    );
                  } else if (header.value === "accordian") {
                    return (
                      <td
                        style={{ textAlign: "center", width: "30px" }}
                        className="data_inside_table"
                      >

                      </td>
                    );
                  }
                })}
              </tr>

              {singleData?.isOpen ? (
                <tr>
                  <td colSpan={4}>
                    <table className="table table-bordered table-responsive">
                      <thead className="thead-light">
                        <GstTableHeader tableHeader={USER_WISE_INNER_HEADERS} />
                      </thead>

                      <tbody>
                        {singleData?.date_wise?.length > 0 &&
                          singleData?.date_wise?.map((insideData: any) => {
                            return (
                              <>
                                <tr>
                                  {USER_WISE_INNER_HEADERS?.map(
                                    (header: TableHeadersType) => {
                                      if (header?.value === "date") {
                                        return (
                                          <td>
                                            {reverseDate(
                                              insideData?.invoice_date
                                            )}
                                          </td>
                                        );
                                      } else if (header?.value === "expenses") {
                                        return (
                                          <td>{insideData?.expense_count}</td>
                                        );
                                      } else if (header?.value === "sales") {
                                        return (
                                          <td>{insideData?.sales_count}</td>
                                        );
                                      } else if (header?.value === "total") {
                                        return (
                                          <td>{insideData?.total_count}</td>
                                        );
                                      }
                                    }
                                  )}
                                </tr>
                              </>
                            );
                          })}
                        
                      </tbody>
                    </table>
                  </td>
                </tr>
              ) : null}
            </>
          );
        })}
    </>
  );
};

export default UserWiseTableData;
